export const formatUSD = (amount, toFixed=4) => {
  let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: toFixed,
  });

  return formatter.format(amount);
}

export const formatNumber = (amount, toFixed=6) => {
  let formatter = new Intl.NumberFormat("en-US", {  maximumFractionDigits: toFixed==="auto" ? (amount > 1000000 ? 0 : amount > 100000 ? 2 : amount < 0.0001 ? 8 : 6) : toFixed });
  return formatter.format(amount);
}

export const formatPrice = (amount, toFixed=6) => {
  let formatter = new Intl.NumberFormat("en-US", {  maximumFractionDigits: toFixed==="auto" ? (amount > 1000 ? 2 : amount > 5 ? 4 : amount < 0.01 ? 6 : amount < 0.001 ? 8 : 2) : toFixed });
  return formatter.format(amount);
}

export function APRtoAPY(apr){
  return ((Math.pow((1+apr/36500),365)-1)*100).toFixed(0);
}

export const ConfettiConfig = {
  angle: 90,
  spread: 360,
  startVelocity: "50",
  elementCount: 70,
  dragFriction: 0.12,
  duration: 3500,
  stagger: 3,
  width: "10px",
  height: "10px",
  perspective: "867px",
  colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"]
};

export const convertHistoricalData = (data, asset) => {
  if (!data)
    return null;
  let arr = [];
  for (let i = 0; i < data.length; i++) {
    for (let token in data[i].tokens) {
      if (token == asset.toUpperCase() || token == asset) {
        arr.push({
          date: data[i].time * 1000,
          price: data[i].tokens[token],
        });
      }
    }
  }
  if (arr.length == 0)
    return null
  return arr;
}


export const GetAssetChart = async (symbol, tokenList, timeFrame=1) => {

  let tokenGeckoId = "";
  if(tokenList) {
    for(let i = 0; i < tokenList.length; i++) {
      if(symbol.toUpperCase() === tokenList[i].symbol) {
        if(tokenList[i].extensions && tokenList[i].extensions.coingeckoId)
          tokenGeckoId = tokenList[i].extensions.coingeckoId;
        break;
      }
    }
  }
  if(!tokenGeckoId) return null;
  
  const params = {
    datapoints: '96',
    duration_days: timeFrame.toString(),
    tokens: [{
      mint: '',
      symbol: symbol,
      token_id: tokenGeckoId
    }],
  }
  let request = await fetch("https://vuer987x5k.execute-api.eu-central-1.amazonaws.com/prod/coin-prices-history/",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(params)
    }
  );
  let response = await request.json();
  return convertHistoricalData(response, symbol.toUpperCase());
}

export const GetInsights = async (timeFrame=1) => {
  // Fetches performers from CoinGecko & PRISM API
  let coinGeckoTimeframe = "";
  let _percent = "";

  if (timeFrame == 1) {
    coinGeckoTimeframe = "24h"
    _percent = "price_change_percentage_24h";
  }
  else if (timeFrame == 7) {
    coinGeckoTimeframe = "7d";
    _percent = "price_change_percentage_7d_in_currency";
  }
  else if (timeFrame === 30) {
    coinGeckoTimeframe = "30d";
    _percent = "price_change_percentage_30d_in_currency";
  }
  let coinGeckoRequest = await fetch("https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&category=solana-ecosystem&order=market_cap_desc&per_page=200&page=1&sparkline=true&price_change_percentage=" + coinGeckoTimeframe);
  let coinGeckoResponse = await coinGeckoRequest.json();
  let performers = [];
  console.log(coinGeckoResponse)

  const sortedPerformers = []
    .concat(coinGeckoResponse)
    .sort((a, b) => (a[_percent] < b[_percent] ? 1 : -1))
    .map(
      (item, i) => (item.current_price && item[_percent]) && performers.push(item)
    );

  performers = [
    parsePerformer(performers[0], _percent),
    parsePerformer(performers[1], _percent),
    parsePerformer(performers[2], _percent),
    parsePerformer(performers[3], _percent),
    parsePerformer(performers[4], _percent),
    parsePerformer(performers[performers.length - 1], _percent),
    parsePerformer(performers[performers.length - 2], _percent),
    parsePerformer(performers[performers.length - 3], _percent),
    parsePerformer(performers[performers.length - 4], _percent),
    parsePerformer(performers[performers.length - 5], _percent)
  ];
  return performers;
}

const parsePerformer = (item, percentValue) => {
  let obj = {
    name: item.name,
    symbol: item.symbol,
    coinGeckoId: item.id,
    marketCap: item.market_cap,
    chart: item.sparkline_in_7d.price,
    change: item[percentValue],
    imageURI: item.image,
    price: item.current_price
  }
  return obj;
}


export const GetTokenData = (symbolOrAddress, tokenList) => {
  for(let i = 0; i < tokenList.tokens.length; i++) {
    if(tokenList.tokens[i].address === symbolOrAddress || tokenList.tokens[i].symbol === symbolOrAddress) {
      let tokenData = Object.assign({}, tokenList.tokens[i]);
      tokenData.balance = 0;
      return tokenData;
    }
  }
  return {
    name: "Unknown",
    symbol: "Unknown",
    address: symbolOrAddress,
    balance: 0,
    decimals: 0
  }
  throw new Error("[GetTokenData] Token not found in tokenlist:" + symbolOrAddress);
}

export const GetTokenBalance = (address, accounts) => {
  for(let i = 0; i < accounts.length; i++) {
    if(accounts[i].mint === address) return {
      balance: accounts[i].balance,
      address: accounts[i].address
    };
  }
  return {
    balance: 0,
    address: null
  }
  throw new Error("[GetTokenBalance] Token not found in accounts: " + address)
}

export const tickLength = (number) => {
  return Math.round(Math.abs(Math.log(number) / Math.log(10)));
}


export const countDecimals = (number) => {
  if (!number || number.length == 0) return 0;
  try { number = number.toString(); } catch (e) {}
  console.log("COUNTDEC", number)
  if(number.indexOf(".") === -1 && number.indexOf(",") === -1) return 0;
  return number.split(".")[1].length || 0; 
}

export const getBaseQuoteTokensFromMint = (tokens, base, quote) => {
  let _base = null;
  let _quote = null;
  for(let i = 0; i < tokens.length; i++) {
    if(tokens[i].address === base) _base = tokens[i];
    else if(tokens[i].address === quote) _quote = tokens[i];

    if(_base && _quote) break;
  }
  return {
    baseToken: _base,
    quoteToken: _quote
  }
}

export const SOL_TOKEN = {
  "chainId": 101,
  "address": "So11111111111111111111111111111111111111112",
  "symbol": "SOL",
  "name": "Wrapped SOL",
  "decimals": 9,
  "logoURI": "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/So11111111111111111111111111111111111111112/logo.png",
  "extensions": {
      "coingeckoId": "solana",
      "serumV3Usdc": "9wFFyRfZBsuAha4YcuxcXLKwMxJR43S7fPfQLusDBzvT",
      "serumV3Usdt": "HWHvQhFmJB3NUcu1aihKmrKegfVxBEHzwVX6yZCKEsi1",
      "website": "https://solana.com/"
  }
}

export const USDC_TOKEN = {
  "chainId": 101,
  "address": "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
  "symbol": "USDC",
  "name": "USD Coin",
  "decimals": 6,
  "logoURI": "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v/logo.png",
  "tags": [
      "stablecoin"
  ],
  "extensions": {
      "coingeckoId": "usd-coin",
      "serumV3Usdt": "77quYg4MGneUdjgXCunt9GgM1usmrxKY31twEy3WHwcS",
      "website": "https://www.centre.io/"
  }
}


export const GET_LIQUIDITY_SOURCE = (source, sources) => {
  for(let i = 0; i < sources.length; i++) {
    if(source === sources[i].source)
      return sources[i];
  }
  console.log("Unknown Liquidity Source", source)
  return {
    website: "unknown",
    icon: "unknown"
  }
}

export const LIQUIDITY_SOURCES = [
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/raydium.svg",
    "website": "https://raydium.io",
    "source": "raydium",
    "program_ids": [
      "675kPX9MHTjS2zt1qfr1NYHuzeLXfQM9H24wFSUt1Mp8"
    ],
    "token_address": "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
    "symbol": "RAY",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/raydium.svg",
    "website": "https://raydium.io",
    "source": "raydium_clamm",
    "program_ids": [
      "CAMMCzo5YL8w4VFF8KVHrK22GGUsp5VTaW7grrKgrWqK"
    ],
    "token_address": "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
    "symbol": "RAY",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/orca.svg",
    "website": "https://orca.so",
    "source": "orca",
    "program_ids": [
      "9W959DqEETiGZocYWCQPaJ6sBmUzgfxXfqGeTEdp3aQP",
      "DjVE6JNiYqPL2QXyCUUh8rNjHrbz9hXHNYt99MQ59qw1"
    ],
    "token_address": "orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE",
    "symbol": "ORCA",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/serum.svg",
    "website": "https://projectserum.com/",
    "source": "serum",
    "program_ids": [
      "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
    ],
    "token_address": "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
    "symbol": "SRM",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/serum.svg",
    "website": "https://projectserum.com/",
    "source": "serum_swap",
    "program_ids": [
      "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
    ],
    "token_address": "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
    "symbol": "SRM",
    "summary": false
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/openbook.png",
    "website": "https://projectserum.com/",
    "source": "openbook",
    "program_ids": [
      "srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX"
    ],
    "token_address": "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
    "symbol": "SRM",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/openbook.png",
    "website": "https://projectserum.com/",
    "source": "openbook_swap",
    "program_ids": [
      "srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX"
    ],
    "token_address": "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
    "symbol": "SRM",
    "summary": false
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/aldrin.png",
    "website": "https://aldrin.com/",
    "source": "aldrin",
    "program_ids": [
      "CURVGoZn8zycx6FXwwevgBTB2gVvdbGTEpvMJDbgs2t4",
      "AMM55ShdkoGRB5jVYPjWziwk8m5MpwyDgsMWHaMSQWH6",
      "TWAPR9s1DEhrr8tuFbwEPws5moHXebMotqU85wwVmvU"
    ],
    "token_address": "E5ndSkaB17Dm7CsD22dvcjfrYSDLCxFcMd6z8ddCk5wp",
    "symbol": "RIN",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/step.svg",
    "website": "https://step.finance/",
    "source": "step",
    "program_ids": [
      "SSwpMgqNDsyV7mAgN9ady4bDVu5ySjmmXejXvy2vLt1"
    ],
    "token_address": "StepAscQoEioFxxWGnh2sLBDFp9d8rvKz2Yp39iDpyT",
    "symbol": "STEP",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/saros.svg",
    "website": "https://saros.finance/",
    "source": "saros",
    "program_ids": [
      "SSwapUtytfBdBn1b9NUGG6foMVPtcWgpRU32HToDUZr"
    ],
    "token_address": "CUSDvqAQLbt7fRofcmV2EXfPA2t36kzj7FjzdmqDiNQL",
    "symbol": "CUSD",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/cropper.svg",
    "website": "https://cropper.finance/",
    "source": "cropper",
    "program_ids": [
      "CTMAxxk34HjKWxQ3QLZK1HpaLXmBveao3ESePXbiyfzh"
    ],
    "token_address": "DubwWZNWiNGMMeeQHPnMATNj77YZPZSAz2WVR5WjLJqz",
    "symbol": "CRP",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/crema.svg",
    "website": "https://www.crema.finance/",
    "source": "crema",
    "program_ids": [
      "6MLxLqiXaaSUpkgMnWDTuejNZEz3kE7k2woyHGVFw319"
    ],
    "token_address": "CRMaDAzKCWYbhUfsKYA8448vaA1qUzCETd7gNBDzQ1ks",
    "symbol": "CRM",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/lifinity.svg",
    "website": "https://lifinity.io/",
    "source": "lifinity",
    "program_ids": [
      "EewxydAPCCVuNEyrVN68PuSYdQ7wKn27V9Gjeoi8dy3S",
      "2wT8Yq49kHgDzXuPxZSaeLaH1qbmGXtEyPy64bL7aD3c"
    ],
    "token_address": "LFNTYraetVioAPnGJht4yNg2aUZFXR776cMeN9VMjXp",
    "symbol": "LFNTY",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/saber.svg",
    "website": "https://saber.so/",
    "source": "saber",
    "program_ids": [
      "SSwpkEEcbUqx4vtoEByFjSkhKdCT862DNVb52nZg1UZ"
    ],
    "token_address": "Saber2gLauYim4Mvftnrasomsv6NvAuncvMEZwcLpD1",
    "symbol": "SBR",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/sencha.webp",
    "website": "https://sencha.so/",
    "source": "sencha",
    "program_ids": [
      "SCHAtsf8mbjyjiv4LkhLKutTf6JnZAbdJKFkXQNMFHZ"
    ],
    "token_address": "",
    "symbol": "",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/mercurial.svg",
    "website": "https://www.mercurial.finance/",
    "source": "mercurial",
    "program_ids": [
      "MERLuDFBMmsHnsBPZw2sDQZHvXFMwp8EdjudcU2HKky"
    ],
    "token_address": "MERt85fc5boKw3BW1eYdxonEuJNvXbiMbs6hvheau5K",
    "symbol": "MER",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/pngfi.svg",
    "website": "https://app.png.fi/swap",
    "source": "penguin",
    "program_ids": [
      "PSwapMdSai8tjrEXcxFeQth87xC4rRsa4VA5mhGhXkP"
    ],
    "token_address": "",
    "symbol": "",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/solana.png",
    "website": "",
    "source": "swap_program",
    "program_ids": [
      "SwaPpA9LAaLfeLi3a68M4DjnLqgtticKg6CnyNwgAC8"
    ],
    "token_address": "",
    "symbol": "",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/whirlpool.svg",
    "website": "",
    "source": "whirlpool",
    "program_ids": [
      "whirLbMiicVdio4qvUfM5KAg6Ct8VwpYzGff3uctyCc"
    ],
    "token_address": "orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE",
    "symbol": "ORCA",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/1sol.png",
    "website": "",
    "source": "onemoon",
    "program_ids": [
      "1MooN32fuBBgApc8ujknKJw5sef3BVwPGgz3pto1BAh"
    ],
    "token_address": "4ThReWAbAVZjNVgs5Ui9Pk3cZ5TYaD9u6Y89fp6EFzoF",
    "symbol": "1SOL",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/cykura.svg",
    "website": "https://cykura.io",
    "source": "cykura",
    "program_ids": [
      "cysPXAjehMpVKUapzbMCCnpFxUFFryEWEaLgnb9NrR8"
    ],
    "token_address": "BRLsMczKuaR5w9vSubF4j8HwEGGprVAyyVgS4EX7DKEg",
    "symbol": "CYS",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/swim.svg",
    "website": "https://swim.io/",
    "source": "swim",
    "program_ids": [
      "SWimmSE5hgWsEruwPBLBVAFi3KyVfe8URU2pb4w7GZs",
      "SWiMDJYFUGj6cPrQ6QYYYWZtvXQdRChSVAygDZDsCHC"
    ],
    "token_address": "",
    "symbol": "",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/dooar.png",
    "website": "https://stepn.com/",
    "source": "dooar",
    "program_ids": [
      "Dooar9JkhdZ7J3LHN3A7YCuoGRUggXhQaG4kijfLGU2j"
    ],
    "token_address": "7i5KKsX2weiTkry7jA4ZwSuXGhs5eJBEjY8vVxR4pfRx",
    "symbol": "GMT",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/marinade.png",
    "website": "https://marinade.finance/",
    "source": "marinade",
    "program_ids": [
      "MarBmsSgKXdrN1egZf5sqe1TMai9K1rChYNDJgjq7aD"
    ],
    "token_address": "MNDEFzGvMt87ueuHvVU9VcTqsAP5b3fTGPsHuuPA5ey",
    "symbol": "MNDE",
    "summary": false
  },
  {
    "icon": "https://raw.githubusercontent.com/birdeye-so/birdeye-ads/main/traders/mango.png",
    "website": "https://mango.markets/",
    "source": "mango",
    "program_ids": [
      "mv3ekLzLbnVPNxjSKvqBpU3ZeZXPQdEC3bp5MDEBG68"
    ],
    "token_address": "MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac",
    "symbol": "MNGO",
    "summary": false
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/symmetry.png",
    "website": "https://www.symmetry.fi/",
    "source": "symmetry",
    "program_ids": [
      "2KehYt3KsEQR53jYcxjbQp2d2kCp4AkuQW68atufRwSr"
    ],
    "token_address": "",
    "symbol": "",
    "summary": false
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/meteora.svg",
    "website": "https://www.mercurial.finance/",
    "source": "meteora",
    "program_ids": [
      "5B23C376Kwtd1vzb5LCJHiHLPnoWSnnx661hhGGDEv8y",
      "Eo7WjKq67rjJQSZxS6z3YkapzY3eMj6Xy8X5EQVn5UaB"
    ],
    "token_address": "",
    "symbol": "",
    "summary": false
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/invariant.png",
    "website": "https://invariant.app/",
    "source": "invariant",
    "program_ids": [
      "HyaB3W9q6XdA5xwpU4XnSZV94htfmbmqJXZcEbRaJutt"
    ],
    "token_address": "",
    "symbol": "",
    "summary": true
  },
  {
    "icon": "",
    "website": "",
    "source": "XuErbiqKKqpvN2X8qjkBNo2BwNvQp1WZKZTDgxKB95r",
    "program_ids": [
      "XuErbiqKKqpvN2X8qjkBNo2BwNvQp1WZKZTDgxKB95r"
    ],
    "token_address": "",
    "symbol": "",
    "summary": false
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/goosefx.png",
    "website": "https://goosefx.io/",
    "source": "goosefx",
    "program_ids": [
      "7WduLbRfYhTJktjLw5FDEyrqoEv61aTTCuGAetgLjzN5"
    ],
    "token_address": "GFX1ZjR2P15tmrSwow6FjyDYcEkoFb4p4gJCpLBjaxHD",
    "symbol": "GOFX",
    "summary": false
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/solanax.png",
    "website": "https://solanax.org/",
    "source": "solanax",
    "program_ids": [
      "Hsn6R7N5avWAL4ScKHYgmwFyhnQ7ZEun94AmTiptPRdA"
    ],
    "token_address": "5v6tZ1SiAi7G8Qg4rBF1ZdAn4cn6aeQtefewMr1NLy61",
    "symbol": "SOLD",
    "summary": false
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/deltafi.png",
    "website": "https://www.deltafi.trade/",
    "source": "deltafi",
    "program_ids": [
      "GNExJhNUhc9LN2DauuQAUJnXoy6DJ6zey3t9kT9A2PF3"
    ],
    "token_address": "",
    "symbol": "",
    "summary": false
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/dradex.jpeg",
    "website": "https://www.dradex.io/",
    "source": "dradex_swap",
    "program_ids": [
      "dp2waEWSBy5yKmq65ergoU3G6qRLmqa6K7We4rZSKph"
    ],
    "token_address": "",
    "symbol": "",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/crema.svg",
    "website": "https://www.crema.finance/",
    "source": "crema_clamm",
    "program_ids": [
      "CLMM9tUoggJu2wagPkkqs9eFG4BWhVBZWkP1qv3Sp7tR"
    ],
    "token_address": "CRMaDAzKCWYbhUfsKYA8448vaA1qUzCETd7gNBDzQ1ks",
    "symbol": "CRM",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/balansol.svg",
    "website": "https://hub.sentre.io/app/balansol/swap?bid_mint=EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v&ask_mint=SENBBKVCM7homnf5RX9zqpf1GFe935hnbU4uVzY1Y6M",
    "source": "balansol",
    "program_ids": [
      "D3BBjqUdCYuP18fNvvMbPAZ8DpcRi4io2EsYHQawJDag"
    ],
    "token_address": "",
    "symbol": "",
    "summary": false
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/pool_providers/marcopolo.svg",
    "website": "https://marcopolo.so/",
    "source": "marcopolo",
    "program_ids": [
      "9tKE7Mbmj4mxDjWatikzGAtkoWosiiZX9y6J4Hfm2R8H"
    ],
    "token_address": "",
    "symbol": "",
    "summary": true
  },
  {
    "icon": "https://cdn.jsdelivr.net/gh/birdeye-so/birdeye-ads/platforms/jupiter.svg",
    "website": "https://jup.ag/",
    "source": "jupiter_limit_order",
    "program_ids": [
      "jupoNjAxXgZ4rjzxzPMP4oxduvQsQtZzyknqvzYNrNu"
    ],
    "token_address": "",
    "symbol": "",
    "summary": false
  }];